import { HubspotCreditsFaqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/HubspotCreditsFaqs';
import { useEffect } from 'react';
import { HubspotCreditsHero } from '../../components/hubspot-credits/HubspotCreditsHero';
import { UnlockAISection } from '../../components/hubspot-credits/UnlockAISection';
import { trackPageView } from '../../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HubspotCreditsPage = () => {
  useEffect(() => {
    trackPageView({
      screen: 'hubspot-credits'
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HubspotCreditsHero, {}), /*#__PURE__*/_jsx(UnlockAISection, {}), /*#__PURE__*/_jsx(HubspotCreditsFaqs, {})]
  });
};